module.exports = __webpack_public_path__ + "img/ics_o_plus.72a75bad.svg";